module.exports = "/_next/static/images/logo-d73b0ba644b18b0f28b07a5bcf5e5b25.svg";